import { z } from 'zod'

import { INVOICE_FOOTER_CHARACTER_LIMIT } from '@features/invoices/constants/invoiceFooterCharacterLimit'
import { INVOICE_MESSAGE_CHARACTER_LIMIT } from '@features/invoices/constants/invoiceMessageCharacterLimit'
import { InvoiceTotalPriceColumns } from '@features/invoices/enums/invoiceTotalPriceColumns'

import { TERMS_AND_CONDITIONS_CHARACTER_LIMIT } from '../../../constants/termsAndConditionsCharacterLimit'
import type { DocumentTypeSettingsFormSchema } from '../types/documentTypeSettingsFormSchema'

export const getDocumentTypeSettingsFormSchema = (): DocumentTypeSettingsFormSchema => {
  return z.object({
    footerNote: z.string().max(INVOICE_FOOTER_CHARACTER_LIMIT),
    isDateColumnVisible: z.boolean(),
    isUnitColumnVisible: z.boolean(),
    message: z.string().max(INVOICE_MESSAGE_CHARACTER_LIMIT),
    shouldShowTermsAndConditions: z.boolean(),
    termsAndConditions: z.string().max(TERMS_AND_CONDITIONS_CHARACTER_LIMIT),
    totalPriceColumns: z.nativeEnum(InvoiceTotalPriceColumns),
  })
}
